import { Container, Divider, Header, SummaryGroup, useAlignments, useSizes } from 'metrix-common3';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Driver from './Driver';

const ProfileDrivers = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const [mode, setMode] = useState('summary');
    const [currentDriver, setCurrentDriver] = useState(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        props.doGetPolicy();
    }, []);

    const getDrivers = () => {
        const drivers = [];

        if (props.policy?.drivers && props.policy.drivers.length > 0) {
            props.policy.drivers.forEach((driver) => {
                const option = { code: 'driver', value: driver.guid };

                let driverName = (
                    <FormattedMessage
                        key={driver.guid}
                        id='Profile_Drivers.driver'
                        values={{ number: driver.number }}
                    />
                );

                if (driver.party?.name) {
                    driverName = `${driver.party.name.firstName} ${driver.party.name.lastName}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: driverName });

                drivers.push(option);
            });
        }

        return drivers;
    };

    const getDriverName = (driver) => {
        let driverName = null;
        const driverGuid = driver || currentDriver;

        if (props.policy?.drivers?.some((x) => x.guid === driverGuid)) {
            const name = props.policy.drivers.find((x) => x.guid === driverGuid).name;

            if (name) {
                driverName = `${name.firstName} ${name.lastName}`;
            }
        }

        return driverName;
    };

    const drivers = getDrivers();
    return (
        <Container>
            {mode === 'summary' && (
                <React.Fragment>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Drivers.drivers' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameters([]);
                                props.doExecutePolicyAction({ code: 'CREATEDRIVER' });
                            }}
                            allowEdit
                            editEvent={(driver) => {
                                setCurrentDriver(driver);
                                setMode('driver');
                                props.doReduceParameters([{ code: 'Driver', value: driver }]);
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(driver) => {
                                props.doReduceParameters([{ code: 'Driver', value: driver }]);
                                props.doExecutePolicyAction({ code: 'DELETEDRIVER' });
                            }}
                            entities={drivers}
                            icon='person'
                        />
                    </Container>
                </React.Fragment>
            )}
            {mode === 'driver' && (
                <Driver
                    driver={props.policy.drivers.find((x) => x.guid === currentDriver)}
                    dotProp={`drivers.${props.policy.drivers.findIndex((x) => x.guid === currentDriver)}.`}
                    getDriverName={getDriverName}
                    backEvent={() => {
                        setMode('summary');
                        setCurrentDriver(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    doReduceParameter={props.doReduceParameter}
                    doExecutePolicyAction={props.doExecutePolicyAction}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
        </Container>
    );
};

export default ProfileDrivers;
